var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"vld-parent"},[_c(_setup.Loading,{attrs:{"active":_setup.ATIVAR_CARREGAMENTO_COMPUTED,"can-cancel":false,"is-full-page":true,"color":"#042333","width":150,"height":150,"enforce-focus":false,"loader":"bars"},on:{"update:active":function($event){_setup.ATIVAR_CARREGAMENTO_COMPUTED=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }